import { Clock } from 'lucide-react';
import type { HoldWarning } from '../../utils/reviewHold';

interface ReviewHoldBannerProps {
  warning: HoldWarning;
  onKeep: () => void;
}

export function ReviewHoldBanner({ warning, onKeep }: ReviewHoldBannerProps) {
  if (warning !== 'soon') return null;
  return (
    <button
      type="button"
      onClick={onKeep}
      className="w-full mb-4 flex items-center gap-2 p-3 rounded-lg bg-amber-50 dark:bg-amber-900/20 border border-amber-300 dark:border-amber-700 text-sm font-medium text-amber-800 dark:text-amber-300 text-left"
    >
      <Clock className="w-4 h-4 flex-shrink-0" />
      Still reviewing? Tap to keep this song
    </button>
  );
}
